import {
  SupplierVariableMappingForm,
  VariableMappingFieldForm,
} from '../models/company-form.model';

const EMPTY_MAPPING_FIELD: VariableMappingFieldForm = {
  incoming: '',
  outgoing: '',
};

export const SUPPLIER_VARIABLE_MAPPING_DTO_KEYS: Record<
  keyof SupplierVariableMappingForm,
  string
> = {
  psSupplierSid: 'ps_supplier_sid',
  psSupplierRespondentId: 'ps_supplier_respondent_id',
  psCustomSvar1: 'ps_custom_svar1',
  psCustomSvar2: 'ps_custom_svar2',
  psTermRsn: 'ps_term_rsn',
  psPsid: 'ps_psid',
  psRstatus: 'ps_rstatus',
  psHash: 'ps_hash',
  psOqid: 'ps_oqid',
  psCpi: 'ps_cpi',
  psSurveyid: 'ps_surveyid',
};

export const SUPPLIER_VARIABLE_MAPPING_DEFAULTS: Record<
  keyof SupplierVariableMappingForm,
  VariableMappingFieldForm
> = {
  psSupplierSid: { incoming: 'ps_supplier_sid', outgoing: 'ps_supplier_sid' },
  psSupplierRespondentId: {
    incoming: 'ps_supplier_respondent_id',
    outgoing: 'ps_supplier_respondent_id',
  },
  psCustomSvar1: { incoming: 'ps_custom_svar1', outgoing: 'ps_custom_svar1' },
  psCustomSvar2: { incoming: 'ps_custom_svar2', outgoing: 'ps_custom_svar2' },
  psTermRsn: EMPTY_MAPPING_FIELD,
  psPsid: EMPTY_MAPPING_FIELD,
  psRstatus: { incoming: 'ps_rstatus', outgoing: 'ps_rstatus' },
  psHash: { incoming: 'ps_s_hash', outgoing: 'ps_s_hash' },
  psOqid: EMPTY_MAPPING_FIELD,
  psCpi: EMPTY_MAPPING_FIELD,
  psSurveyid: EMPTY_MAPPING_FIELD,
};

/** Keys always present in the outbound payload, regardless of value. */
export const SUPPLIER_VARIABLE_MAPPING_ALWAYS_ON_KEYS: readonly (keyof SupplierVariableMappingForm)[] =
  [
    'psSupplierSid',
    'psSupplierRespondentId',
    'psCustomSvar1',
    'psCustomSvar2',
    'psPsid',
    'psRstatus',
    'psHash',
  ];

/** Keys only included in the outbound payload when their outgoing value is set. */
export const SUPPLIER_VARIABLE_MAPPING_OPTIONAL_KEYS: readonly (keyof SupplierVariableMappingForm)[] =
  ['psTermRsn', 'psOqid', 'psCpi', 'psSurveyid'];
